<template>
<v-card >
  <v-img :aspect-ratio="16/9" height=150 v-if='value' :src='value' >
    <v-card-title  >
      <v-chip large >Current image</v-chip>
      <v-spacer></v-spacer>
      <v-btn @click='$emit("close")' >Update picture</v-btn>
    </v-card-title>
  </v-img>
  <!-- <v-tabs v-model='activeTab' >
    <v-tab >Search</v-tab>
    <v-tab >Enter a url</v-tab>
    <v-tabs-items v-model='activeTab' >
      <v-tab-item > -->
        <v-toolbar dense flat>
          <v-toolbar-title>{{title}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            label='Search background images'
            @click:append='search'
            @keyup.enter='search'
            v-model='searchString'
            append-icon="search" class='mt-3' ></v-text-field>
        </v-toolbar>
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex xs4 md3 lg2
              v-for="img in images"
              :key="img.id" class='text-xs-center' >
              <!-- <div v-if='activeImg === img.id' class='mt-3' >
                <v-progress-circular indeterminate :size="50" color="amber"></v-progress-circular>
                <div>Setting background</div>
              </div> -->
              <v-img :aspect-ratio="16/9" @click="$emit('input', img.urls.regular)" class="image" :src="img.urls.thumb" >
              </v-img>
            </v-flex>
          </v-layout>
        </v-container>
      <!-- </v-tab-item>
      <v-tab-item >
        <v-text-field
            label='Type the URL of an image to use'
            v-model='manualUrl' class='ma-3' solo >
        </v-text-field>
      </v-tab-item>
    </v-tabs-items>
  </v-tabs> -->
</v-card>
</template>
<script>
import axios from 'axios'
export default {
  name: 'ImageSearch',
  props: {
    value: { type: String, required: false },
    title: {type: String, default: 'Choose a background'},
    initialSearch: { type: String, default: 'wellness' }
  },
  data () {
    return {
      activeTab: 0,
      searchString: '',
      searchResponse: {},
      manualUrl: '',
      loading: false
    }
  },
  mounted () {
    this.searchString = this.initialSearch
    this.search()
  },
  computed: {
    images () {
      return this.getObjectPath(this.searchResponse, 'data.results', [])
    },
    perPage () {
      return 24
    }
  },
  methods: {
    search () {
      let payload = {
        headers: {
          Authorization: 'Client-ID e844ef6b655e466ae6355a7ad45e990ca3f96928ad4fa9dc1e6a3939592a3039'
        }
      }
      let vm = this
      vm.loading = true
      let url = `https://api.unsplash.com/search/photos?query=${this.searchString}&orientation=landscape&per_page=${this.perPage}`
      axios.get(url, payload)
        .then((data) => {
          vm.searchResponse = data
          vm.loading = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ImageSearch.vue?1562c860